// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgPeopleFullBodyCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      d="M10.435 7.5c0-.828.7-1.5 1.562-1.5.863 0 1.562.672 1.562 1.5s-.7 1.5-1.562 1.5c-.862 0-1.562-.672-1.562-1.5zM11.997 14.51l-.756 3.265a.31.31 0 0 1-.302.225H9.66a.305.305 0 0 1-.31-.337l.813-6.3-2.908-.523a.3.3 0 0 1-.25-.35l.23-1.18a.312.312 0 0 1 .365-.24l3.597.648a3.939 3.939 0 0 0 1.606 0l3.597-.647c.17-.03.333.076.364.24l.23 1.179a.301.301 0 0 1-.249.35l-2.908.524.813 6.3a.305.305 0 0 1-.31.336H13.06a.31.31 0 0 1-.302-.225z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10zM12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgPeopleFullBodyCircle;
